export default function PillButton({
  text="",
  onClick=() => null,
  selected=false,
} : {
  text?: string,
  onClick?: () => void,
  selected?: boolean,
}) {
  return (
    <button className={`flex w-full justify-center border rounded-full border-black
      py-1 ${selected ? "bg-[#a19881]" : "bg-[#BCB7A8]"} hover:bg-[#a19881]
      transition duration-100
    `} onClick={onClick}>{text}</button>
  )
}
